module.exports = __webpack_public_path__ + "static/media/Anzeige.c0faec60.png";